import { enUS, arSA } from '@mui/material/locale';

export const allLangs = [
  {
    label: 'العربية',
    value: 'ar',
    systemValue: arSA,
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
  },
];

export const defaultLang = allLangs[1]; // English
